
let language = {

    FILE_LIBRARY_NO_MORE_CONTENT_TIP: "No more content...",
    FILE_LIBRARY_NO_MATCH_SEARCH_TIP: "There is no match for the search criteria.",
    FILE_LIBRARY_FOLDER_EMPTY_TIP: "This folder is empty.",
    FILE_LIBRARY_NOT_HAVE_FILE_LIBRARY_TIP: "You don't have a file library yet, please click the button below to create your file library.",
};

export { language }